import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import classNames from 'volta/helpers/class-names';
import type { SpaceScale } from '@bevolta/design-tokens';
import type { TOC } from '@ember/component/template-only';
interface BvTextContainerSignature {
    Args: {
        spacing?: SpaceScale;
    };
    Blocks: {
        default: [];
    };
    Element: HTMLDivElement;
}
const BvTextContainerComponent: TOC<BvTextContainerSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <div
    class={{classNames
      'bv-text-container'
      (if @spacing (concat 'bv-text-container--spacing-' @spacing))
    }}
    ...attributes
  >
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvTextContainerComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvTextContainer: typeof BvTextContainerComponent;
        'bv-text-container': typeof BvTextContainerComponent;
    }
}
